import type { EventAnalyticsSummary } from './types'

export function percentChange(
  current: number,
  previous: number
): number | null {
  // Both zero → no meaningful trend
  if (previous === 0 && current === 0) return null
  // No previous data → can't compute a real % change
  if (previous === 0) return null
  return ((current - previous) / previous) * 100
}

export function eventsPerSessionValue(summary?: EventAnalyticsSummary): number | null {
  const sessions = summary?.unique_sessions ?? 0
  const events = summary?.total_events ?? 0
  if (sessions === 0) return null
  return events / sessions
}

export function clickThroughRateValue(summary?: EventAnalyticsSummary): number | null {
  const views = summary?.by_event?.apartment_viewed ?? 0
  const clicks = summary?.by_event?.apartment_clicked ?? 0
  if (views === 0) return null
  return (clicks / views) * 100
}

export function eventCount(
  summary: EventAnalyticsSummary | undefined,
  eventName: string
): number {
  return summary?.by_event?.[eventName] ?? 0
}
